import { fetchApi } from '@/config/axiosSetting.ts';

import {
  GetBodyVehicleCorrectiveImageTabsResponceType,
  GetBodyVehicleCorrectiveImageTabsType,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyVehicleCorrectiveImageTabs/getBodyVehicleCorrectiveImageTabs.type';

export const getBodyVehicleCorrectiveImageTabsFunction = (
  params?: GetBodyVehicleCorrectiveImageTabsType,
): Promise<GetBodyVehicleCorrectiveImageTabsResponceType> =>
  fetchApi({
    url: `/body/reports/${params?.id}/images/corrective/entry_tabs/`,
  });
